module.exports = __webpack_public_path__ + "media/images/sarapoint/a_point-55ba93f36b2a8adde1ff5ad78c4d9e50.svg";